import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    createNewRegistration,
    updateEditRegistration
} from '../../../product/shared/repositories';
import {
    successAlertBar,
    warningAlertBar
} from '../../../shared/services/alert-bar';
import actions from '../../actions-list';
import {getDefaultState as getRegistrationDefaultState} from '@deere/cps-it.warranty-model-factory/lib/registration';
import {resetProductDetails} from './product-details';
import {routerActions} from 'react-router-redux';
import {translate} from '../../../shared/services/translation-service';
import {updatePrintRegistrationFormModal} from './registration-modals';

const showModalOrReroute = data =>
    !data.registrationFormNotAllowed && data.statusIndicator === 'NEW' ?
        updatePrintRegistrationFormModal(true, data.route, data.registrationId)(data.dispatch) :
        data.dispatch(routerActions.push(data.route));

/* eslint-disable complexity, max-depth */

export const handleRegistrationSubmit = (registration, user, registerAnother, saveExistingRegistration) =>

    async dispatch => {

        const statusIndicator = registration.statusIndicator.key;

        let response,
            route;

        dispatch(busyCounter.increaseBusyCounter());

        try {

            if (saveExistingRegistration && registration.id) {

                response = await updateEditRegistration(registration.id, registration);
                route = `/products/${response.product.pin}`;
                successAlertBar(translate('REGISTRATION_UPDATED_SUCCESSFULLY'));
                dispatch(routerActions.push(route));

            } else {

                if (registration.id) {

                    response = await updateEditRegistration(registration.id, registration);

                    route = '/products';

                } else {

                    response = await createNewRegistration(registration);

                    route = `/products/${response.product.pin}`;

                }

                if (registerAnother) {

                    route = '/products/register-product';

                    dispatch({
                        registration: getRegistrationDefaultState(),
                        type: actions.PRODUCT_REGISTRATION_REGISTER_ANOTHER_PRODUCT
                    });

                    resetProductDetails()(dispatch);

                }

                if (response.status === 'PENDED') {

                    warningAlertBar('PRODUCT_REGISTRATION_PENDED');

                    dispatch(routerActions.push(route));

                } else {

                    const registrationFormNotAllowed = user.privacy.registrationFormNotAllowed;

                    successAlertBar(translate('REGISTRATION_SUCCESS'));

                    showModalOrReroute({
                        dispatch,
                        registrationFormNotAllowed,
                        registrationId: response.id,
                        route,
                        statusIndicator
                    });

                }

            }

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

/* eslint-enable complexity, max-depth */



// WEBPACK FOOTER //
// ./src/product/product-registration/action-creators/handle-submit.js